import React, { useState } from 'react';

// set up amplify config
import { Amplify, Auth } from 'aws-amplify';
import awsconfig from '../../../src/aws-exports';

import '../../../src/styles/login.css';

// Import generic components
import Button from '../../generic_components/Button/Button';
import Input from '../../generic_components/Input/Input';
import { useToast } from '../../generic_components/Toast/Toast';
import '../../../src/styles/login.css';

Amplify.configure(awsconfig);



const ForgotPassword = ({  username, onClose }) => {
  const [userEmail, setUserEmail] = useState(username);

    const [newPassword, setNewPassword] = useState(''); 
    const [code, setCode] = useState('');
    const [step, setStep] = useState(1);  
    const [showPassword, setShowPassword] = useState(false);
    
    const toast = useToast();

    const handleForgotPassword = async () => {
        try {
          if (userEmail.trim() === '') {
            toast.error('Please enter your registered email.', {
              hideProgressBar: true
            });
            return;
          }
          await Auth.forgotPassword(userEmail);
          setStep(2);
        } catch (err) {
          console.log(err);
          toast.error(err.message, {
            hideProgressBar: true
          });
        }
      }
    
      const handleForgotPasswordSubmit = async () => {
        try {
          await Auth.forgotPasswordSubmit(username, code, newPassword);
          let successMsg = 'Your password has been changed successfully. Please login with the new password.';
          toast.success(successMsg, {
            hideProgressBar: true
          });
          
          onClose();
          // You can redirect the user to the login page or display a success message.
        } catch (err) {
          console.log(err);
           toast.error(err.message, {
            hideProgressBar: true
          });
        }
      }

  const handleShowPassword = () => {
    setShowPassword(prev => !prev);
  };

   


  return (
  
        <div > 
           {step === 1 && (
            <form
              onSubmit={(e) => {
                e.preventDefault(); // prevent page reload
                handleForgotPassword(); // trigger Request Code
              }}
            >
              <Input
                label={userEmail ? "Registered email:" : "Enter your registered email:"}
                placeholder={userEmail ? userEmail : "Enter your registered email here"}
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
              />
              <div className='forgot-password-text'>
                Request Confirmation Code by clicking the button below.
              </div>

              {/* type='submit' ensures Enter key triggers this */}
              <Button variant='primary' type='submit'>
                Request code
              </Button>
            </form>
          )}


            {step === 2 && (
              <form
                onSubmit={(e) => {
                  e.preventDefault(); // Prevent page reload
                  handleForgotPasswordSubmit(); // Trigger your submit logic
                }}
              >
                <div className='verification-code-label'>
                  <p>
                    A verification code has been sent to <span style={{ color: '#e08a20' }}>{userEmail}</span>
                  </p>
                  <p style={{ marginBottom: '1em', color: '#ccc', fontSize: '0.9em' }}>
                    Check your spam or junk folder if missing.
                  </p>
                  <p>Please enter the code and new password below, then click Submit.</p>
                </div>

                <Input
                  label="Verification code:"
                  placeholder="Verification Code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  size='lg'
                />
                <br />

                <div style={{ position: 'relative' }}>
                  <Input
                    label="New password:"
                    size='lg'
                    type={showPassword ? "text" : "password"}
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    showPasswordToggle
                  />
                  <button
                    className='show-password-btn'
                    style={{ top: '68%' }}
                    type='button'
                    onClick={handleShowPassword}
                  >
                    {showPassword
                      ? <i className="fa-regular fa-eye-slash"></i>
                      : <i className="fa-regular fa-eye"></i>
                    }
                  </button>
                </div>
                <br />

                {/* Set type='submit' so Enter key triggers this */}
                <Button
                  className='forgot-password-submit-btn'
                  type='submit'
                >
                  Submit
                </Button>
              </form>
            )}
        </div>
  )
}

export default ForgotPassword